
import { defineComponent, ref, computed } from "vue";
import { useStore } from "@/store";
import { useRouter } from "vue-router";
import BaseInput from "@/components/base/BaseInput.vue";
import BaseButton from "@/components/base/BaseButton.vue";
import BaseLoader from "@/components/base/BaseLoader.vue";
import { AxiosError } from "axios";
import { notify } from "@kyvg/vue3-notification";

export default defineComponent({
  name: "LoginPage",
  components: {
    "base-input": BaseInput,
    "base-button": BaseButton,
    "base-loader": BaseLoader,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const loading = ref(false);
    const phone = ref("");

    const isPhoneValid = computed(() => phone.value.length === 15);

    const startLoading = () => {
      loading.value = true;
    };

    const navigateToVerificationCodePage = () => {
      router.push({ name: "auth.verification" });
    };

    const finishLoading = () => {
      loading.value = false;
    };

    const handleErrorInLogin = (e: AxiosError) => {
      const error = e.response?.data?.message;
      if (error && error.status === "pending") {
        notify({
          text: `Повторная отправка смс-кода возможна только через ${error.resend_cooldown} секунд`,
          type: "error",
          ignoreDuplicates: true,
          duration: 5000,
        });
      }
    };

    const clearMaskedPhoneNumber = () => {
      return phone.value.replaceAll(/[() -]/g, "");
    };

    const handleFormSubmit = () => {
      const clearedPhone = clearMaskedPhoneNumber();
      const phoneWithPrefix = `+7${clearedPhone}`;
      if (!isPhoneValid.value) return;
      startLoading();
      store
        .dispatch("sendVerificationCode", phoneWithPrefix)
        .then(navigateToVerificationCodePage)
        .catch(handleErrorInLogin)
        .finally(finishLoading);
    };

    return {
      handleFormSubmit,
      phone,
      loading,
      isPhoneValid,
    };
  },
});
